import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "menu-header" }
const _hoisted_6 = { class: "my-8" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "my-8" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "my-12 d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_time_input = _resolveComponent("time-input")!
  const _component_billing_input = _resolveComponent("billing-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.inputValue && _ctx.spans)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("h5", null, "延長パターン名", -1)),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.inputValue.patternTitle,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue.patternTitle) = $event)),
            variant: "outlined",
            "hide-details": "",
            density: "compact"
          }, null, 8, ["modelValue"])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "menu-header" }, "固定時間枠（幼稚園）", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", null, "開始時刻", -1)),
            _createVNode(_component_time_input, {
              hour: _ctx.inputValue.startingHour,
              onHour: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue.startingHour = Number($event))),
              minute: _ctx.inputValue.startingMinute,
              onMinute: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputValue.startingMinute = Number($event)))
            }, null, 8, ["hour", "minute"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_billing_input, {
              billingMethod: _ctx.inputValue.earlyHoursBillingFee.billingMethod,
              onBillingMethod: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputValue.earlyHoursBillingFee.billingMethod = $event)),
              hourly: _ctx.inputValue.earlyHoursBillingFee.hourly,
              onHourly: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputValue.earlyHoursBillingFee.hourly = $event)),
              monthly: _ctx.inputValue.earlyHoursBillingFee.monthly,
              onMonthly: _cache[5] || (_cache[5] = ($event: any) => (_ctx.inputValue.earlyHoursBillingFee.monthly = $event))
            }, null, 8, ["billingMethod", "hourly", "monthly"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spans.spans, (item, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createElementVNode("div", _hoisted_5, "時間枠" + _toDisplayString(i+1), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("h5", null, "開始時刻", -1)),
                _createVNode(_component_time_input, {
                  hour: item.startingHour,
                  onHour: ($event: any) => (item.startingHour = Number($event)),
                  minute: item.startingMinute,
                  onMinute: ($event: any) => (item.startingMinute = Number($event))
                }, null, 8, ["hour", "onHour", "minute", "onMinute"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("h5", null, "終了時刻", -1)),
                _createVNode(_component_time_input, {
                  hour: item.endingHour,
                  onHour: ($event: any) => (item.endingHour = Number($event)),
                  minute: item.endingMinute,
                  onMinute: ($event: any) => (item.endingMinute = Number($event))
                }, null, 8, ["hour", "onHour", "minute", "onMinute"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_billing_input, {
                  billingMethod: item.billingMethod,
                  onBillingMethod: ($event: any) => (item.billingMethod = $event),
                  hourly: item.hourly,
                  onHourly: ($event: any) => (item.hourly = $event),
                  monthly: item.monthly,
                  onMonthly: ($event: any) => (item.monthly = $event)
                }, null, 8, ["billingMethod", "onBillingMethod", "hourly", "onHourly", "monthly", "onMonthly"])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.addSpanRow,
            color: "primary",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-plus", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.isUpdatable)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: _ctx.updatePattern,
                loading: _ctx.isLoading,
                color: "primary",
                variant: "flat",
                large: ""
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("保存", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                onClick: _ctx.createPattern,
                loading: _ctx.isLoading,
                color: "primary",
                variant: "flat",
                large: ""
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("作成", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "loading"]))
        ])
      ]))
    : _createCommentVNode("", true)
}